import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import DefRoutes from "../../../routes/routes.json";
import t from "../../../i18n/i18n";
import initPage from "../../../utils/initPage";

import Template from "../../../template/template";
import Membership from "../../../components/membership/membership";

function Benefits() {
  initPage({ title: t("LoyalMember.Statics.Benefits.Title") });

  const { user } = useSelector((store) => store.auth);
  const { name, nickname, avatar, credits } = user;

  return (
    <Template>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="loyal-member-warp">
              <div className="loyal-oque-warp">
                <div className="oque-top">
                  <div className="profile-panel-box">
                    <div className="profile-col">
                      <div className="user-name-info">
                        <span className="user-thumb">
                          <img src="/images/benefic-ico.png" alt="" />
                        </span>
                        <div className="user-name-title">
                          <span className="name text-uppercase">{t("LoyalMember.Statics.Benefits.Title")}</span>
                          <small className="text-uppercase">{t("LoyalMember.Title")}</small>
                        </div>
                      </div>
                      <div className="profile-top-intro">
                        <p dangerouslySetInnerHTML={{ __html: t("LoyalMember.Statics.Benefits.SubTitle") }} />
                      </div>
                    </div>
                    <div className="membership-panel-col">
                      <div className="membership-inner black">
                        <div className="credit-data">
                          <span className="icon">
                            <img src="/images/credit-ico-large.png" alt="" />
                          </span>
                          {t("General.YouHave")} <h6>{credits || 0}</h6>
                          <small>{t("General.Credits")}</small>
                        </div>
                        <div className="membership-colwarp">
                          <Membership user={user} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="packege-warp">
                  <ul className="pack-list">
                    <li className="sliver-pack">
                      <div className="pack-list-box">
                        <figure>
                          <img src="/images/pack-media1.png" alt="" />
                        </figure>
                        <h2>SILVER</h2>

                        <ol dangerouslySetInnerHTML={{ __html: t("LoyalMember.Statics.Benefits.Silver") }} />

                        <div className="apply-btn">
                          <Link to={DefRoutes.RewardsType.replace(":type", "Silver")} className="btn-pack btn-sliver">
                            {t("LoyalMember.Statics.Benefits.SeeMore")}
                          </Link>
                        </div>
                      </div>
                    </li>
                    <li className="gold-pack">
                      <div className="pack-list-box">
                        <figure>
                          <img src="/images/pack-media2.png" alt="" />
                        </figure>
                        <h2>Gold</h2>

                        <ol dangerouslySetInnerHTML={{ __html: t("LoyalMember.Statics.Benefits.Gold") }} />

                        <div className="apply-btn">
                          <Link to={DefRoutes.RewardsType.replace(":type", "Gold")} className="btn-pack btn-sliver">
                            {t("LoyalMember.Statics.Benefits.SeeMore")}
                          </Link>
                        </div>
                      </div>
                    </li>
                    <li className="platinum-pack">
                      <div className="pack-list-box">
                        <figure>
                          <img src="/images/pack-media3.png" alt="" />
                        </figure>
                        <h2>PLATINUM</h2>

                        <ol dangerouslySetInnerHTML={{ __html: t("LoyalMember.Statics.Benefits.Platinum") }} />

                        <div className="apply-btn">
                          <Link to={DefRoutes.RewardsType.replace(":type", "Platinum")} className="btn-pack btn-sliver">
                            {t("LoyalMember.Statics.Benefits.SeeMore")}
                          </Link>
                        </div>
                      </div>
                    </li>
                    <li className="diamond-pack">
                      <div className="pack-list-box">
                        <figure>
                          <img src="/images/pack-media4.png" alt="" />
                        </figure>
                        <h2>DIAMOND</h2>

                        <ol dangerouslySetInnerHTML={{ __html: t("LoyalMember.Statics.Benefits.Diamond") }} />

                        <div className="apply-btn">
                          <Link to={DefRoutes.RewardsType.replace(":type", "Diamond")} className="btn-pack btn-sliver">
                            {t("LoyalMember.Statics.Benefits.SeeMore")}
                          </Link>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="bottom-adv-box">
                  <div className="chargin-banner-box">
                    <a href="#">
                      <img src={t("Images.A013")} className="view-large" />
                      <img src={t("Images.A014")} className="view-small" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Template>
  );
}

export default Benefits;
